/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_TransferInputs */

const cs_properties_bulk_transfer = /** @type {(inputs: Properties_Bulk_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převést vybrané`)
};

const en_properties_bulk_transfer = /** @type {(inputs: Properties_Bulk_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer selected`)
};

/**
* | output |
* | --- |
* | "Transfer selected" |
*
* @param {Properties_Bulk_TransferInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer = /** @type {((inputs?: Properties_Bulk_TransferInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_TransferInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer(inputs)
	return cs_properties_bulk_transfer(inputs)
});